/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Search_Email_PlaceholderInputs */

const en_samples_search_email_placeholder = /** @type {(inputs: Samples_Search_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search email...`)
};

const es_samples_search_email_placeholder = /** @type {(inputs: Samples_Search_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar correo...`)
};

/**
* | output |
* | --- |
* | "Search email..." |
*
* @param {Samples_Search_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_search_email_placeholder = /** @type {((inputs?: Samples_Search_Email_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Search_Email_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_search_email_placeholder(inputs)
	return es_samples_search_email_placeholder(inputs)
});